module.exports = require("././angular-touch.js");


//////////////////
// WEBPACK FOOTER
// angular-touch (bower component)
// module id = 1082
// module chunks = 1